import { MLM, MsTracking, TrackingType } from '@sunrise/tracking'

import { DecoratedEstate } from '../../../ts/mapper/decoratedItemEstate.interface'
import { ActionIds, MLMData } from '../../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../../ts/tracking/mlmStaticTrackingData'
import { buildMlmResultListItems } from '../../../ts/utils/trackingUtils'

export function buildMlmTrackingData(
    componentId: string,
    items: DecoratedEstate[],
    url: string,
    isExposeeOnline: boolean,
): MsTracking {
    const actionId = isExposeeOnline ? ActionIds.RECOMMENDER_VIEW_ONLINE : ActionIds.RECOMMENDER_VIEW_OFFLINE
    return MLM.createMlmTracking(
        {
            ...staticMlmTrackingData,
            page: MLMData.DEFAULT_PAGE as number,
            actionId,
            componentId,
            pageUrl: url,
            items: items ? buildMlmResultListItems(items) : [],
        },
        TrackingType.PAGE_VIEW,
    )
}
